import { Query } from "react-apollo";
import gql from "graphql-tag";
import { AssetVariable, AssetOutput, RentalAdvert, SprocketAsset, Route, RouteOutput, RouteVariable } from "../../../types/types";
import { user_query, assets_query } from "../shared/advertiser_info";
import { GeneralRentalBooleans, InteriorRentalBooleans, SurroundingsRentalBooleans, ActivitiesRentalBooleans } from "../../../advert_detail/booleans";
import { ToGraphqlVariable } from "../../routes";

export type AdvertiserInfoAssets = {
  "placeholder_user.png": SprocketAsset
  "google_maps/overview/marker.png": SprocketAsset
}

type QueryVariables = {
  advert_id: number
  locale: string
  assets: AssetVariable<AdvertiserInfoAssets>[]
  routes: RouteVariable<Routes>[]
}


export type QueryResult = {
  rental_advert: RentalAdvert
  assets: AssetOutput<AdvertiserInfoAssets>[]
  siteSettings: {
    googleMapsKey: string
  }
  routes: RouteOutput<Routes>[]
}

export type Routes = {
  corona_policy_url: Route,
}


export class RentalContentQuery extends Query<QueryResult, QueryVariables> { }

export const query = () => {
  return gql`
    query AdvertContent($assets: [AssetInput!]!, $advert_id: ID!, $locale: String, $routes: [RouteInput!]!) {
      siteSettings {
        googleMapsKey
      }
      routes: routes(routes: $routes) {
        url
        path
        name
        identifier
      }
      rental_advert:rentalAdvert(id:$advert_id) {
        type
        detailPeriodBlocksUrl
        objectName
        advertiserFullName
        objectType
        hasNotIncludedFees
        hasIncludedFees
        hasAdditionalFees
        regionOverviewPath
        cityOverviewPath
        departmentOverviewPath
        overviewPath
        skiDistanceTranslation
        longitude
        latitude
        skiArea {
          name
        }
        translations(locale:$locale) {
          nodes {
            locale
            pricesText
            interior
            locationText
            activities
            culture
            remarks
            skiDistanceText
          }
        }
        bnbRooms {
          nodes {
            id
            name
            maxPersons
            twinBeds
            singleBeds
            hasSink
            hasToilet
            hasBathAndShower
            hasShower
            hasBath
            hasInternet
            hasTerrace
            hasTv
            hasCoffeeAndTea
            hasDvd
            hasRadio
            hasTelephone
            cdPlayer
            translations(locale:$locale) {
              nodes {
                locale
                description
              }
            }
            photobookPhotos {
              nodes {
                image {
                  url(crop:"detail_thumb")
                }
              }
            }
          }
        }
        youtubeUrl
        ${GeneralRentalBooleans().join("\n")}
        ${InteriorRentalBooleans().join("\n")}
        ${SurroundingsRentalBooleans().join("\n")}
        ${ActivitiesRentalBooleans().join("\n")}

        region {
          id
          name
          staticAbstractMapSvg
          area {
            path
            name
          }
        }
        department {
          id
          name
        }
        city {
          id
          name
        }
        ${user_query()}
      }
      ${assets_query()}
    }
  `
}


export const variables = (advert_id: number, locale: string) : QueryVariables => {
  return {
    advert_id: advert_id,
    locale: locale,
    assets: [
      {
        identifier: "placeholder_user.png"
      },
      {
        identifier: "google_maps/overview/marker.png"
      }
    ],
    routes: ToGraphqlVariable<Routes>({
      corona_policy_url: { "name": "page", "args":{ "slug": "corona_policy_tenant" } },
    })

  }
}
